import { useDispatch } from "react-redux";
import { DataSeekContainer } from "../../components/DataSeek";
import { useEffect } from "react";
import { fetchDataset } from "../../redux/actions/dataset";
import { useSelector } from "react-redux";

interface DatasetPageProps {
  request: any;
}

export const DatasetPage: React.FC<DatasetPageProps> = ({ request }) => {
  const dispatch = useDispatch();

  const dataset = useSelector((state: any) => {
    return state.dataset.item;
  });

  useEffect(() => {
    dispatch(fetchDataset({ 
      appId: request.appId, 
      datasetId: request.datasetId, 
      language: request.language 
    }));
  }, [request]);

  if(!dataset) {
    return false;
  }

  return (
    <DataSeekContainer account={request.appId} dataset={dataset} language={request.language} />
  );
}